import React from 'react'

import { Root } from './styles'

const Button = (props: any) => {
  return <Root onClick={props.onClick}>{props.children}</Root>
}

export default Button
